import de from './de.json'
import en from './en.json'

const messages: Record<string, Record<string, string>> = { de, en }
const defaultLang = 'de'
const fallbackLang = 'en'
const availableLang = ['de', 'en']

export { messages, defaultLang, fallbackLang, availableLang }
